import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

export default function CriticalError(props) {    

    return ( 
        <Alert severity="warning">
            { props?.message?.length > 0 ? ( 
                <Typography variant="body2">
                    <strong>A critical error occurred. </strong><br />
                    {props?.message}</Typography>
            ) : ( 
                <Typography variant="body2"><strong>A critical error occurred. Please refresh the page.</strong></Typography>
            )}
        </Alert>        
    )
    
}